import styled from "styled-components"
import { colors } from "../../../../../../lib/colors"
import { coefficientColorCheck } from "../../../../../helpers/coefficientColor"

interface live_score_button {
  prevRounds: boolean
}

export const LiveScoresHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 0 10px; */
  z-index: 1;
`

export const LiveScoresHeaderBets = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;

  h1 {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    text-align: center;
    color: ${colors.lightGrey};
    text-transform: uppercase;
    @media only screen and (min-width: 768px) {
      font-size: 20px;
    }
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    text-align: center;
    color: ${colors.liveBetsGreen};
  }
`
interface previous_number_props {
  number: number
}

export const PreviousRoundCoef = styled.div<previous_number_props>`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  text-align: center;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
  align-items: center;
  padding: 4px 6px;
  gap: 10px;
  pointer-events: none;
  background: ${({ number }) => coefficientColorCheck(number)};
  border-radius: 2px;
  @media only screen and (min-width: 768px) {
    font-size: 14px;
  }
`
export const LiveScoreButton = styled.div<live_score_button>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 92px;
  height: 20px;
  border: ${({ prevRounds }) =>
    prevRounds ? `1px solid ${colors.liveBetsDarkGreen}` : "1px solid #363640"};
  border-radius: 100px;
  cursor: pointer;
  svg {
    margin-left: 5px;
  }
  h1 {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: ${({ prevRounds }) =>
      prevRounds ? colors.liveBetsGreen : colors.lightGrey};
    margin-right: 8px;
  }
  @media only screen and (min-width: 768px) {
    width: unset;
    height: unset;
    padding: 2px;
    svg {
      margin-left: 1px;
      margin-right: 2px;
      width: 16px;
      height: 16px;
    }
    h1 {
      font-size: 16px;
      margin-right: 5px;
      /* padding-bottom: 1px; */
    }
  }
`
